<template>
	<div>
		<org-vehicle-list :update="update"></org-vehicle-list>
		<br>
		<br>
		<br>
		<br>
		<v-fab-transition>
			<v-btn :disabled="!$can('createVehicle')" color="primary" class="screen-fixed" fixed right fab x-large @click="openDialog++">
				<v-icon>mdi-car</v-icon>
			</v-btn>
		</v-fab-transition>
		<pvcam-wc-vehicle :on="openDialog" :org="org" :org-name="orgName" />
	</div>
</template>

<script>
	import { mapActions, mapGetters } from "vuex";
	import { Logger } from "aws-amplify";
	const logger = new Logger("OrgVehicles");
	import { AmplifyEventBus } from "aws-amplify-vue";
	import { ListAccessibleOrgs } from "@/services/API.js";
	import OrgVehicleList from "./Sections/OrgVehicleList.vue";

	export default {
		components: {
			OrgVehicleList
		},
		data: () => ({
			openDialog: 0,
			update: 0,
			types: [],
			setTypes: [],
			orgs: []
		}),
		computed: {
			...mapGetters("presence", [
      "vehicleStatus", "mapData"
    ]),
			org() {
				if (this.$route.params.name) {
					logger.info(this.$route.params.name, this);
					return this.$route.params.name;
				}
				return null;
			},
			orgName() {
				if (this.orgs.length > 0) {
					let org = this.orgs.find(org => {
						return org.id == this.org;
					});
					return org.name;
				}	
				else {
					return '';
				}
			}
		},
		mounted() {
			this.getVehiType();
			this.getOrgs();
		},
		methods: {
			...mapActions(["getVehiType"]),
			getOrgs() {
				ListAccessibleOrgs()
				.then(res => {
					this.orgs = res.sort((a, b) => a.name.localeCompare(b.name));
				})
				.catch(err => {
					AmplifyEventBus.$emit("snackEvent", {
						color: "error",
						text: err
					});
				});
			}
		}
	};
</script>